import { Grid } from "@material-ui/core";
import { Create, Datagrid, DeleteWithConfirmButton, Edit, Filter, Labeled, List, Show, SimpleForm, SimpleShowLayout, TextField, TextInput, useNotify, useRecordContext } from "react-admin";
import { AssetBulkActionButtons } from "./components";

const VipFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User ID" source="user_id" alwaysOn />
  </Filter>
);

const CustomDelete = () => {
  const record = useRecordContext();
  return <DeleteWithConfirmButton record={record} confirmTitle={"Delete Vip Ad Free " + record.user_id} />;
};

export const VipsList = (props) => (
  <List {...props} sort={{ field: "user_id", order: "ASC" }} bulkActionButtons={<AssetBulkActionButtons />} filters={<VipFilter />}>
    <Datagrid>
      <TextField source="user_id" />
      {/* <ShowButton />
          <EditButton /> */}
      <CustomDelete />
    </Datagrid>
  </List>
);

export const VipEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic" title={<VipTitle />}>
      <SimpleForm>
        <TextInput source="user_id" />
      </SimpleForm>
    </Edit>
  );
};

const redirect = () => "/vips";

const VipTitle = ({ record }) => {
  return <span>VIP {record ? `${record.user_id}` : ""}</span>;
};

export const VipCreate = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Create {...props} onFailure={onFailure}>
      <SimpleForm redirect={redirect}>
        <TextInput source="user_id" />
      </SimpleForm>
    </Create>
  );
};
export const VipShow = (props) => (
  <Show {...props} title={<VipTitle />}>
    <SimpleShowLayout>
      <Grid container>
        <Grid item sm={12} md={6}>
          <Labeled label="User ID">
            <TextField source="user_id" />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  </Show>
);
